import { EmptyState, FlexRow, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { HeadingSmall } from 'baseui/typography';
import { generatePath, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { LIVE_PAGE } from '../../../constants/app';
import { useStyles } from '../../../hooks/useStyles';
import { workspaceState } from '../../../storage/app';
import { loadingCurrentStatesState } from '../../../storage/currentStates';
import { streamingCurrentStateState, streamingState } from '../../../storage/streaming';
import { StreamingState } from '../../../types/streaming';
import StreamingCurrentState from './StreamingCurrentState';

function StreamingDetail() {
  const { theme, classes, css } = useStyles();
  const streaming = useRecoilValue(streamingState);
  const channelsCount = useRecoilValue(streamingCurrentStateState)?.asset.channels;
  const frontIsOk = streaming.frontState === StreamingState.ok;
  const internalIsOk = streaming.internalState === StreamingState.ok;
  const domeIsOk = streaming.domeState === StreamingState.ok;
  const streamingIsActive = channelsCount === 2 ? frontIsOk || internalIsOk : frontIsOk || internalIsOk || domeIsOk;
  const navigate = useNavigate();
  const workspace = useRecoilValue(workspaceState);
  const currentState = useRecoilValue(streamingCurrentStateState);
  const loading = useRecoilValue(loadingCurrentStatesState);

  const onCloseStreaming = () => {
    const route = generatePath(LIVE_PAGE.route, { id: workspace?._id });
    navigate(route, { replace: true });
  };

  if (loading) {
    return <Loading />;
  }

  if (!currentState) {
    return (
      <EmptyState
        title="Dispositivo no encontrado"
        action={
          <StyledButton
            shape="pill"
            onClick={onCloseStreaming}
          >
            Volver al inicio
          </StyledButton>
        }
        style={{ gap: theme.sizing.scale600 }}
      />
    );
  }

  return (
    <>
      <FlexRow classNames={css({ justifyContent: 'space-between', alignItems: 'center' })}>
        <HeadingSmall margin={0}>Transmisión en vivo</HeadingSmall>
        <FlexRow
          centered
          gap={theme.sizing.scale200}
        >
          <StyledButton
            size="mini"
            shape="pill"
            kind="secondary"
            onClick={onCloseStreaming}
          >
            <FlexRow
              classNames={classes.centeredStart}
              gap={theme.sizing.scale200}
            >
              <MaterialIcon
                name="live"
                size="mini"
                color={streamingIsActive ? theme.colors.negative : theme.colors.contentPrimary}
              />
              Cerrar en vivo
            </FlexRow>
          </StyledButton>
        </FlexRow>
      </FlexRow>
      <StreamingCurrentState />
    </>
  );
}

export default StreamingDetail;
